import SectionHead from "./SectionHead";

export default function Technologies({ technologies }) {
  return (
    <section className="py-20  pt-2 md:pt-20" style={{ background: "#f8f8fb" }}>
      <div className="max-w-7xl mx-auto px-3">
        <SectionHead eyebrow={technologies.eyebrow} title={technologies.title} sub={technologies.subtitle} />
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-4">
          {technologies.stacks.map((stack, i) => (
            <div key={i} className="dc-card p-5">
              <div className="flex items-center gap-2 font-extrabold text-sm mb-4" style={{ color: stack.color }}>
                <div className="w-2 h-2 rounded-full" style={{ background: stack.color }} />
                {stack.group}
              </div>
              <div className="flex flex-wrap gap-1.5">
                {stack.items.map((item, j) => (
                  <span key={j} className="text-xs font-semibold px-2.5 py-1 rounded-lg"
                    style={{ background: stack.bg, color: stack.color }}>
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}